import * as React from "react";

import { TernaryFilterOption } from "../../../../types/index";
import GenericTernaryButtonGroupFilter from "../../GenericTernaryButtonGroupFilter";

interface Props {
  contractExistingFilterState: TernaryFilterOption;
  onChange: (filter: TernaryFilterOption) => void;
  disabled?: boolean;
}

class ContractExistingOptions extends React.Component<Props> {
  public render() {
    return (
      <GenericTernaryButtonGroupFilter
        title="Vertrag vorhanden"
        filterState={this.props.contractExistingFilterState}
        disabled={this.props.disabled}
        onChange={this.props.onChange}
      />
    );
  }
}

export default ContractExistingOptions;



// WEBPACK FOOTER //
// ./src/components/Filters/ProductTypeFilter/FilterOptions/ContractExistingOptions.tsx